const swiperGalleryPopup = new Swiper(".gallery__popup__slider", {
  loop: false,
  spaceBetween: 0,
  speed: 400,
  slidesPerView: 1,
  navigation: {
    nextEl: ".gallery__popup__slider-next",
    prevEl: ".gallery__popup__slider-prev",
  },
  pagination: {
    el: ".gallery__popup__slider-pagination",
    clickable: true,
  },
//   autoplay: {
//     delay: 3000,
//     disableOnInteraction: false,
//   },
});

const buttonGalleryOpen = document.querySelector('.gallery__item__button');

if (buttonGalleryOpen) {
  buttonGalleryOpen.addEventListener('click', e => {
    document.querySelector('.gallery__popup').classList.add('open');
    document.querySelector('body').classList.add('open-gallery');
  })
}

const buttonGalleryClose = document.querySelector('.gallery__popup__close');

if (buttonGalleryClose) {
  buttonGalleryClose.addEventListener('click', closeGallery);
}

const galleryPopup = document.querySelector('.gallery__popup');
if (galleryPopup) {
  galleryPopup.addEventListener('click', function(e) {
    if (e.target === this) {
      closeGallery();
    }
  });
}

function closeGallery() {
  document.querySelector('.gallery__popup').classList.remove('open');
  document.querySelector('body').classList.remove('open-gallery');
}